export default __webpack_public_path__ + "static/media/bimw.883aafb5.png";